import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PhoneMaskDirective } from './phone-mask.directive';

@NgModule({
  declarations: [PhoneMaskDirective],
  imports: [ReactiveFormsModule],
  exports: [PhoneMaskDirective],
})
export class PhoneMaskModule {}
